import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Redirect, Route, RouteComponentProps } from 'react-router-dom';
import './index.css';
import { RoomEditor } from './components/drawing/editor/FloorplanEditor';
import reportWebVitals from './reportWebVitals';
import { Home } from './Home';
import { initializeIcons } from '@fluentui/react';
import { PrivacyPolicy } from './components/policies/PrivacyPolicy';
import { CheckIn } from './components/checkin';

const Editor = (props: RouteComponentProps<{ floorplanId: string, layoutId: string }>) => {
    const { params } = props.match;
    const layoutId = parseInt(params.layoutId, 10);
    return <RoomEditor {...props} floorplanId={params.floorplanId as string} layoutId={layoutId} />
};

initializeIcons();

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <Route path="/" exact={true}>
                <Redirect to="/menu" />
            </Route>
            <Route path="/menu" component={Home} />
            <Route path="/privacy">
                <PrivacyPolicy />
            </Route>
            <Route path="/admin/layoutEditor/floorplan/:floorplanId/:layoutId" exact={true} component={Editor} />
            <Route path="/check-in/:siteId/:locationId/:roomId" exact={true} component={(route: RouteComponentProps<{ siteId: string, locationId: string, roomId: string }>) => {
                return <CheckIn {...route.match.params} />;
            }} />
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
